module.exports = __webpack_public_path__ + "img/three.2162defb.png";